import { PARENT_ALLOWED_ORIGINS } from "./constants";

const WILDCARD_ORIGIN = "*";

const normalizeOrigin = (origin: string) => {
  if (origin === WILDCARD_ORIGIN) return WILDCARD_ORIGIN;
  try {
    return new URL(origin).origin;
  } catch {
    return null;
  }
};

export const getTargetOrigins = (): string[] => {
  const origins = PARENT_ALLOWED_ORIGINS.map(normalizeOrigin).filter((origin): origin is string => !!origin);
  return origins.includes(WILDCARD_ORIGIN) ? [WILDCARD_ORIGIN] : origins;
};

export const isAllowedOrigin = (origin: string) => {
  const origins = getTargetOrigins();
  return origins.includes(WILDCARD_ORIGIN) || origins.includes(origin);
};

export const postMessageToParent = (message: unknown) => {
  getTargetOrigins().forEach((targetOrigin) => window.parent.postMessage(message, targetOrigin));
};
